export const data = () => ({
  documents: [],
  loading: false
})
